import { Form, Input } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './TempFieldsList.styles';
interface IProps {
  id: string;
  isSelected: boolean;
  readableArea: string;
  onClick: () => void;
  onFocus: () => void;
}

const TempFieldsListItem: FC<IProps> = ({
  id,
  onClick,
  isSelected,
  readableArea,
  onFocus,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <S.FieldsListCollapseItem
      // props for Collapse component
      {...props}
      key={id}
      $isSelected={isSelected}
      header={
        <S.FieldsListItemHeader $isSelected={isSelected} onClick={onClick}>
          <S.FieldId $isSelected={isSelected}>{id}</S.FieldId>
          <S.FieldArea $isSelected={isSelected}>{readableArea}</S.FieldArea>
        </S.FieldsListItemHeader>
      }
      showArrow={false}
    >
      <Form.Item
        name={id}
        rules={[
          {
            required: isSelected,
            message: t(
              'Field.TempFieldsListItem.EmptyFieldNameInputError',
              'Field name is required',
            ),
          },
        ]}
      >
        <Input
          placeholder={t(
            'Field.TempFieldsListItem.FieldNamePlaceholder',
            'Field name',
          )}
          onFocus={onFocus}
        />
      </Form.Item>
    </S.FieldsListCollapseItem>
  );
};

export default TempFieldsListItem;
